﻿import { ethers } from "ethers";

export class BiMath 
{
    public static get Decimal():bigint{ return BigInt("1000000000000000000"); }
    public static get Decimal17B():bigint{ return BigInt("100000"); }
    public static get Decimal20():bigint{ return BigInt("100000000000000000000"); }
    public static get Zero():bigint{ return BigInt(0); }
    public static ToBI(valueEth:string):bigint {
        if (valueEth=="") valueEth="0";
        return ethers.parseEther(valueEth);
    }
    public static ToBIFromNumber(num:number):bigint {return this.ToBI(num+"");}
    public static ToEth(valueBI:bigint):string {
        const result = ethers.formatEther(valueBI);
        return (result === "0.0" || result === "0.") ? "0" : result;
    }
    public static TruncEth(valueEth:string, decimal:number){
        if (!valueEth.includes(".")) return valueEth;
        const [integerPart, decimalPart] = valueEth.split(".");
        const trimmedDecimalPart = decimalPart.slice(0, decimal);
        return trimmedDecimalPart ? `${integerPart}.${trimmedDecimalPart}` : integerPart;
    }

    public static isValidAddress (address: string) {
        return ethers.isAddress(address);
    };
}